import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-4/5 bg-white rounded-md mt-4 mx-auto h-screen mb-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl" }, "User Config", -1)
const _hoisted_3 = { class: "mx-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-left" }, "Nickname", -1)
const _hoisted_5 = { class: "w-full text-left my-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-left my-2" }, "Profile", -1)
const _hoisted_8 = { class: "w-full text-left" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "text-red-600 font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.nickname) = $event)),
              class: "flex-grow p-2 border rounded-md",
              disabled: _ctx.loading
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.user.nickname]
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("textarea", {
              class: "w-full max-w-[400px] h-24 border-2",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.profile) = $event)),
              disabled: _ctx.loading
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.user.profile]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              type: "submit",
              value: "Submit",
              class: "py-2 px-4 text-white rounded cursor-pointer bg-blue-500 mt-4",
              disabled: _ctx.loading
            }, null, 8, _hoisted_10)
          ]),
          (_ctx.saved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Saved"))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ])
  ]))
}